import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/home/MainHome.vue'
import MembershipPage from './membership';
import CertificationPage from './certification';
import TrainingPage from './training';
import ContactPage from './contact';
import notice from './notice';
import login from './login';
import education from './education';
import about from './about';
// import test from './test';
import iicc from './iicc';
import news from './news';
import qna from './qna';
import archive from './archive';
import landing from './landing';
// import ai from './ai';

// ✅ 라우터 생성
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },

    ...notice,
    ...login,
    ...about,
    ...MembershipPage,
    ...CertificationPage,
    ...TrainingPage,
    ...ContactPage,
    ...education,
    // ...test,
    ...iicc,
    ...news,
    ...qna,
    ...archive,
    ...landing,
    // ...ai,
  ],
  scrollBehavior() {
    return { top: 0 }
  }
})

/* --------------------------------------------------------------------------
  ✅ 회원가입 단계별 직접 접근 차단 (예: /join-step1 → /join-step2 → /join-step3)
  sessionStorage를 이용해서 사용자가 1단계부터 순서대로 진행했는지 확인합니다.
-------------------------------------------------------------------------- */
// router/index.js

const JOIN_KEY = 'joinProgress' // '0'|'1'|'2'|'3' 등

router.beforeEach((to, from, next) => {
  // 1) 조인 플로우에서 벗어나는 순간 진행상태 초기화
  const isJoin = (p) => p?.startsWith('/join-')
  if (isJoin(from.path) && !isJoin(to.path)) {
    sessionStorage.removeItem(JOIN_KEY)
  }

  // 2) 단계 접근 가드 (기존 로직)
  const joinRoutes = ['/join-step1', '/join-step2', '/join-step3']
  if (!joinRoutes.includes(to.path)) return next()

  const progress = Number(sessionStorage.getItem(JOIN_KEY) || '0')

  if (to.path === '/join-step1') return next()
  if (to.path === '/join-step2' && progress < 1) {
    return next({ path: '/join-step1', replace: true })
  }
  if (to.path === '/join-step3' && progress < 2) {
    return next({ path: '/join-step1', replace: true })
  }

  next()
})


export default router
